module.exports = __webpack_public_path__ + "a754da73e2ee8df966db6c182d1371ae.png";